import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'utcDate',
  standalone: false,
})
export class UtcDatePipe extends DatePipe implements PipeTransform {
  public override transform(value: any, args?: any): any {
    return super.transform(value, args, 'UTC');
  }
}
